import Icon from "../../../../components/ui/Icon";
import Photo from "../../../../components/ui/Photo";
import { formatBRL } from "../../../../helpers/currency.helper";
import { Row, PhotoWrap, Texts, Name, Desc, Price, Check } from "./ChoiceOptionRow.styles";

interface ChoiceOptionRowProps {
  name: string;
  desc?: string;
  price?: number;
  /** Foto do sabor/produto. Ausente = sem thumbnail (ex.: opcoes de etapa). */
  photo?: string;
  checked: boolean;
  onClick: () => void;
}

export default function ChoiceOptionRow({ name, desc, price, photo, checked, onClick }: ChoiceOptionRowProps) {
  return (
    <Row type="button" $checked={checked} onClick={onClick}>
      {photo !== undefined && (
        <PhotoWrap>
          <Photo src={photo} label={name} radius={12} />
        </PhotoWrap>
      )}
      <Texts>
        <Name>{name}</Name>
        {desc && <Desc>{desc}</Desc>}
      </Texts>
      {!!price && price > 0 && <Price $checked={checked}>+ {formatBRL(price)}</Price>}
      <Check $checked={checked}>{checked && <Icon name="check" size={14} color="#fff" strokeWidth={3} />}</Check>
    </Row>
  );
}
